import Anita from "../../assets/Anita.jpg";
import Will from "../../assets/Will.jpg";
import Johaira from "../../assets/johaira.jpg";
import Joel from "../../assets/Joel.jpg";
import Mario from "../../assets/mario.webp";
import Erica from "../../assets/Erica.jpg";
import Sedrick from "../../assets/Sedrick.jpg";

import Luna from "../../assets/luna.jpg";
import JayJay from "../../assets/JayJay.jpg";
import Jacob from "../../assets/Jacob.jpg";

export const FriendsList = [
  {
    name: "Anita S.",
    location: "Yogykarta, Indonesia",
    testimony:
      "I've known Genne for 10 years, and she is a close friend of mine. She has a wonderful personality: humble, honest, and thoughtful. She shows great wisdom whenever she faces challenges and needs to solve problems. She is responsible and always gives her best in her career. From the first time I met Genne, I was impressed by how passionately she spoke about her goals and how hard she worked to achieve her dream job. She is enthusiastic and creative, and she has excellent communication skills, which help her connect easily with people around her and with people from all over the world during her travels.",
    image: `${Anita}`,
  },
  {
    name: "Jay Jay",
    location: "Taipei, Taiwan",
    testimony:
      "Genne gives off such kind, welcoming energy. She's easy to talk to, always shares positive words, and laughs with her whole heart.",
    image: `${JayJay}`,
  },

  {
    name: "Will G.",
    location: "New York, USA",
    testimony:
      "I met Genne as a student on a study abroad trip to New Zealand. She was one of many however she stood out as seemingly more insightful into the local culture/geography than others. That’s what drew me in as I thought along the same lines. Over the 2 weeks and then few years after that outside of New Zealand I saw her as a big sister to confide things in. She’s kind maybe to a fault in making sure everyone’s fine before herself. She’s adaptable, able to jump in any new situation with a open mind and open view. She’s perseverant, fighting through the meanders of life, and certainly a unorthodox life path. And lastly she’s adventurous. To plan world trips, whether it’s days or months, cities or mountains, developed or developing areas, she has a idea of what to do and she’s stubborn enough to execute it where others would fail. That’s my view of Genne.",
    image: `${Will}`,
  },
  {
    name: "Joel G.",
    location: "Texas, USA",
    testimony:
      "As a leader, Genne is exceptional; her employees genuinely enjoy working for her, and she consistently maintains a positive demeanor, demonstrating a proactive and capable approach to addressing any challenge. She is an inspiring and invaluable friend who works diligently toward her goals and always follows through on her commitments. Outside of work, her greatest passion is traveling the world to remote natural places and connecting with native people. Even with a busy schedule, she remains one of my closest friends of over ten years, always making an effort to stay connected.",
    image: `${Joel}`,
  },
  {
    name: "Mario R.",
    location: "Texas, USA",
    testimony:
      "To live in accordance with one's conscience is a paramount belief I uphold. Genne truly embodies such actions. She is self reflective to her core and strives to outdo herself on a daily basis. I have seldom met anyone in this world who can be more family to me than her. Her passion and drive cannot be outworked; and her love for life, friends, and family cannot be undone. She is more than the co-founder of SkinSort to me. She is a light in the dark when you can't see, and an oasis in the desert when you are in need of rest. Her friendship can provide anyone the wherewithal to become a better person themselves. She is, and forever shall be, family to me.",
    image: `${Mario}`,
  },
  {
    name: "Johaira G.",
    location: "Texas, USA",
    testimony:
      "Genne possesses a rare combination of sharp intelligence, relentless dedication, and passionate work ethic. Her loyalty as a friend is unmatched, deeply rooted in a genuine commitment to the well-being of those she cares about. Observing her strategically build and scale SkinSort has been truly inspiring.",
    image: `${Johaira}`,
  },
  {
    name: "Sedrick Y.",
    location: "Texas, USA",
    testimony:
      "Genne is one of the most socially and analytically intelligent people I know!",
    image: `${Sedrick}`,
  },
];
